import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=48114406&scoped=true"
import script from "./GlobalSearch.vue?vue&type=script&lang=ts"
export * from "./GlobalSearch.vue?vue&type=script&lang=ts"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&id=48114406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48114406",
  null
  
)

export default component.exports